import './App.css';
import AppRoutes from "./routes/AppRoutes";
import {BrowserRouter} from "react-router-dom";
import {useAuth} from "./context/AuthContext";
import {useEffect, useState} from "react";
import {CircularProgress} from "@mui/material";

function App() {
    const {setUserToken, setUserData, setInstitutionData} = useAuth();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const loadUserData = () => {
            const token = localStorage.getItem("token");
            const user = localStorage.getItem("user");
            const institution = localStorage.getItem("institution");
            if (token && user) {
                setUserToken(token);
                setUserData(JSON.parse(user));
                setInstitutionData(JSON.parse(institution))
            }
            setLoading(false);
        };
        loadUserData();
    }, []);

    if (loading) return (<CircularProgress/>);

    return (
        <BrowserRouter>
            <AppRoutes/>
        </BrowserRouter>
    );
}

export default App;
